"use client"

import clsx from "clsx"

import type { AllNullable } from "@unlikelystudio/commerce-connector"

import type { PropsWithClassName } from "~/@types/generics"
import useOptionsTranslate from "~/hooks/useOptionTranslate"
import { OPTION_SIZE } from "~/components/ui/Product/ProductHeader/_data/constants"
import type { VariantOptionWithoutColor } from "~/components/ui/Product/ProductHeader/_data/utils/get-uniq-variants-without-color"

import { sprinkles } from "~/styles/sprinkles.css"

import * as css from "./styles.css"

type ProductOptionsSelectorProps = PropsWithClassName<{
  options: AllNullable<VariantOptionWithoutColor>[]
  currentOption: VariantOptionWithoutColor | null
  onChange: (option: VariantOptionWithoutColor) => void
  sizeChartPanel: React.ReactNode
  children?: React.ReactNode
}>

function ProductOptionsSelector({
  className,
  options,
  currentOption,
  onChange,
  sizeChartPanel,
  children,
}: ProductOptionsSelectorProps) {
  const title = useOptionsTranslate(OPTION_SIZE)

  return (
    <>
      <div
        className={clsx(css.ProductSizesSelector, className)}
        data-comp="UI/Product/ProductHeader/ProductDetails/ProductSelector/ProductOptionsSelector"
      >
        <div>
          <header
            className={sprinkles({
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mB: 20,
              pX: 10,
            })}
          >
            <span className={clsx(css.title)}>{title}</span>
            {sizeChartPanel}
          </header>
          <div className={css.sizesSelector}>
            {options?.map((option, index) => {
              const isActive = currentOption?.value === option.value

              return (
                <button
                  key={`item_option_${index}`}
                  onClick={() => {
                    option.id && onChange(option)
                  }}
                  className={clsx(css.sizesSelectorItem, {
                    [css.buttonVariants.active]: isActive,
                    [css.buttonVariants.disabled]: !option.availableForSale,
                  })}
                >
                  {option.value}
                </button>
              )
            })}
          </div>
        </div>
      </div>
      {children}
    </>
  )
}

export { ProductOptionsSelector, type ProductOptionsSelectorProps as ProductSizesSelectorProps }
